class TopProducts {
  constructor() {
    this.grid = document.querySelector("#product-grid");
    if (!this.grid) return;

    const params = new URLSearchParams(location.search);
    const top = params.get("top");

    if (!top) return;

    this.handles = top
      .split(",")
      .map(v => v.trim())
      .filter(Boolean);
      
    // 💡 额外保护：去重，防止 URL 里输入了重复的 handle
    this.handles = [...new Set(this.handles)];

    this.renderSkeletons();
    this.load();
  }

  renderSkeletons() {
    // ✅ 修复点 1：将数组倒序后再 prepend，保证骨架屏一开始就是正序显示的
    this.handles.slice().reverse().forEach(handle => {
      const el = document.createElement("div");
      el.className = "f-column top-product is-loading";
      el.dataset.productHandle = handle;

      el.innerHTML = this.getSkeletonHTML();

      this.grid.prepend(el);
    });
  }

  async load() {
    const results = await Promise.all(
      this.handles.map(handle => this.fetchProduct(handle))
    );

    results.forEach((html, index) => {
      const handle = this.handles[index];

      if (!html) return;

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const productCard = temp.querySelector(".product-card");

      if (!productCard) return;

      // ✅ 修复点 2：在插入新加载的卡片前，删掉网格中所有带这个 handle 的元素
      // （包括刚才生成的骨架屏，以及原来商品列表中自带的该产品）
      this.removeExisting(handle);

      const wrapper = document.createElement("div");
      wrapper.className = "f-column top-product";
      wrapper.dataset.productHandle = handle;

      wrapper.appendChild(productCard);

      this.grid.prepend(wrapper);
    });

    // 重新统一排序
    this.reorderDom();
  }

  reorderDom() {
    const nodes = Array.from(this.grid.querySelectorAll(".top-product"));
    const map = new Map();

    nodes.forEach(node => {
      const h = node.dataset.productHandle;
      if (h) map.set(h, node);
    });

    // ✅ 修复点 3：同样使用倒序 prepend，确保最终 DOM 结构完全吻合你输入的 handle 正序
    this.handles.slice().reverse().forEach(handle => {
      const node = map.get(handle);
      if (node) {
        this.grid.prepend(node);
      }
    });
  }

  removeExisting(handle) {
    // ⚠️ 重点注意：这里会删除所有带 data-product-handle="xxx" 的节点。
    // 如果你发现原来的商品没有消失，说明原商品 HTML 没有这个属性！
    const nodes = this.grid.querySelectorAll(
      `[data-product-handle="${handle}"]`
    );

    nodes.forEach(n => n.remove());
    
    // 💡 备用删除方案：如果原来的商品容器没有 data-product-handle，
    // 你可以利用商品链接里的 handle 来定位并删除原有产品。
    // 取消下方代码的注释，并把 '.product-card-wrapper' 替换为你原网格商品的实际父类名：
    /*
    const originalLinks = this.grid.querySelectorAll(`a[href*="/products/${handle}"]`);
    originalLinks.forEach(link => {
      const originalCard = link.closest('.product-card-wrapper'); // 替换为你实际的 class
      if (originalCard && !originalCard.classList.contains('top-product')) {
        originalCard.remove();
      }
    });
    */
  }

  async fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}?view=top-card`);
      if (!res.ok) return null;
      return await res.text();
    } catch (e) {
      console.error("fetch failed:", handle);
      return null;
    }
  }

  getSkeletonHTML() {
    return `
      <div class="product-card skeleton">
        <div class="skeleton-img"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
      </div>
    `;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new TopProducts();
});